import { FEATURES, STEPS } from "../../data/landing";

export const FeaturesSection = () => (
  <section id="features" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
    <div className="mx-auto max-w-2xl text-center">
      <p className="text-xs font-bold uppercase tracking-[0.15em] text-indigo-500">Everything you need</p>
      <h2 className="mt-2 font-heading text-3xl font-black text-slate-900 sm:text-4xl">Built for the field, not the office</h2>
    </div>
    <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
      {FEATURES.map((f) => (
        <div key={f.title} data-testid={`feature-${f.title}`} className="rounded-2xl border-2 border-slate-200 bg-white p-6 transition-all hover:border-indigo-500 hover:shadow-md">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-50">
            <f.icon className="h-6 w-6 text-indigo-500" strokeWidth={2.5} />
          </div>
          <h3 className="mt-4 font-heading text-lg font-bold text-slate-900">{f.title}</h3>
          <p className="mt-2 text-sm text-slate-600">{f.desc}</p>
        </div>
      ))}
    </div>
  </section>
);

export const HowItWorks = () => (
  <section id="how" className="border-y border-slate-200 bg-slate-50">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="font-heading text-3xl font-black text-slate-900 sm:text-4xl">Three steps. Done before you leave.</h2>
      </div>
      <div className="mt-12 grid gap-8 md:grid-cols-3">
        {STEPS.map((s) => (
          <div key={s.n} className="rounded-2xl border-2 border-slate-200 bg-white p-8">
            <div className="flex h-12 w-12 items-center justify-center rounded-full bg-indigo-500 font-heading text-xl font-black text-white">{s.n}</div>
            <h3 className="mt-5 font-heading text-xl font-bold text-slate-900">{s.title}</h3>
            <p className="mt-2 text-slate-600">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
